import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=c3ca0c90&scoped=true&lang=pug&"
import script from "./loader.vue?vue&type=script&lang=js&"
export * from "./loader.vue?vue&type=script&lang=js&"
import style0 from "./loader.vue?vue&type=style&index=0&id=c3ca0c90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ca0c90",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsResultsFigure: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/widgets/results/figure.vue').default,WidgetsResultsAccordion: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/widgets/results/accordion.vue').default,WidgetsResultsCta: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/widgets/results/cta.vue').default,WidgetsResultsItem: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/widgets/results/item.vue').default})
